import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

export const usePatientDuePayments = () => {
  const patientId = useCurrentPatientId();

  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["patientDuePayments", patientId, tenantVal],
    queryFn: async () => {
      if (!patientId || !tenantVal) return null;
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/consultationpaymentdue/getbypatientid/${patientId}`
      );
      return response.data;
    },
    enabled: !!patientId && !!tenantVal,
    meta: { errorMessage: "Error fetching patient due payments data" },
  });
};
